import { asiakasSetting_set, asiakasSettings_get } from "./AsiakasSettingsFunctions";

export default class asiakasSettingsClass {
  asiakasSettingId;
  asiakasId;
  laskuttajaAsiakasId;
  asiakasSettingTypeId;
  asiakasSettingTypeNimi;
  asiakasSettingString;
  asiakasSettingBool;
  asiakasSettingInt;
  asiakasSettingJSON;
  asiakasSettingsHash;
  constructor(asiakasId, laskuttajaAsiakasId, asiakasSettingTypeId) {
    this.asiakasId = asiakasId;
    this.laskuttajaAsiakasId = laskuttajaAsiakasId;
    this.asiakasSettingTypeId = asiakasSettingTypeId;
    this.asiakasSettingId = null;
    this.asiakasSettingTypeNimi = "";
    this.asiakasSettingString = null;
    this.asiakasSettingBool = false;
    this.asiakasSettingInt = null;
    this.asiakasSettingJSON = null;
    this.asiakasSettingsHash = this.getHash();
  }

  getHash() {
    const c =
      this.asiakasSettingId +
      this.asiakasId +
      this.laskuttajaAsiakasId +
      this.asiakasSettingTypeId +
      (this.asiakasSettingTypeNimi || "") +
      (this.asiakasSettingString || "") +
      (this.asiakasSettingBool ? "t" : "f") +
      this.asiakasSettingInt +
      (this.asiakasSettingJSON || "");
    return c;
  }
}
export function asiakas_hasPumiFi(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 1).asiakasSettingBool;
}
export function asiakas_setPumiFi(asiakas, value) {
  if (!asiakas) return false;
  asiakasSetting_set(asiakas, asiakas.asiakasId, 1, value);
}
export function asiakas_hasTyö(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 12).asiakasSettingBool;
}
export function asiakas_setTyö(asiakas, value) {
  if (!asiakas) return false;
  asiakasSetting_set(asiakas, asiakas.asiakasId, 12, value);
}
export function asiakas_hasTiedostot(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 11).asiakasSettingBool;
}
export function asiakas_setTiedostot(asiakas, value) {
  if (!asiakas) return false;
  asiakasSetting_set(asiakas, asiakas.asiakasId, 11, value);
}

export function asiakas_hasLaskutus(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 9).asiakasSettingBool;
}

export function asiakas_setLaskutus(asiakas, value) {
  if (!asiakas) return false;
  const _settings = asiakasSettings_get(asiakas, asiakas.asiakasId, 9);
  asiakasSetting_set(
    asiakas,
    asiakas.asiakasId,
    9,
    value,
    _settings.asiakasSettingInt,
    _settings.asiakasSettingString
  );
}

export function asiakas_hasNetvisor(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 2).asiakasSettingBool;
}
export function asiakas_setNetvisor(asiakas, value) {
  if (!asiakas) return false;
  asiakasSetting_set(asiakas, asiakas.asiakasId, 2, value);
}

export function asiakas_hasLemonsoft(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 3).asiakasSettingBool;
}
export function asiakas_setLemonsoft(asiakas, value) {
  if (!asiakas) return false;
  asiakasSetting_set(asiakas, asiakas.asiakasId, 3, value);
}

export function asiakas_hasHenkilöt(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 4).asiakasSettingBool;
}
export function asiakas_setHenkilöt(asiakas, value) {
  if (!asiakas) return false;
  asiakasSetting_set(asiakas, asiakas.asiakasId, 4, value);
}

export function asiakas_hasSijainnit(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 5).asiakasSettingBool;
}
export function asiakas_setSijainnit(asiakas, value) {
  if (!asiakas) return false;
  asiakasSetting_set(asiakas, asiakas.asiakasId, 5, value);
}

export function asiakas_hasAjoneuvot(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 6).asiakasSettingBool;
}
export function asiakas_setAjoneuvot(asiakas, value) {
  if (!asiakas) return false;
  asiakasSetting_set(asiakas, asiakas.asiakasId, 6, value);
}

export function asiakas_hasTuotteet(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 7).asiakasSettingBool;
}
export function asiakas_setTuotteet(asiakas, value) {
  if (!asiakas) return false;
  asiakasSetting_set(asiakas, asiakas.asiakasId, 7, value);
}

export function asiakas_hasToimitus(asiakas) {
  return asiakas.hasToimitus;
}
export function asiakas_setToimitus(asiakas, boolValue) {
  if (!asiakas) return false;
  const _settings = asiakasSettings_get(asiakas, asiakas.asiakasId, 8);
  //console.log(a);
  asiakasSetting_set(
    asiakas,
    asiakas.asiakasId,
    8,
    boolValue,
    _settings.asiakasSettingInt,
    _settings.asiakasSettingString
  );
}
export function asiakas_hasToimitus_rule(asiakas) {
  if (!asiakas) return false;
  return asiakasSettings_get(asiakas, asiakas.asiakasId, 8).asiakasSettingString;
}
export function asiakas_setToimitus_rule(asiakas, ruleString) {
  if (!asiakas) return false;
  const boolValue = asiakas_hasToimitus(asiakas);
  asiakasSetting_set(asiakas, asiakas.asiakasId, 8, boolValue, null, ruleString);
}
export function asiakas_getDefaultDailyMessages(asiakas) {
  if (!asiakas) return false;
  const j = asiakasSettings_get(asiakas, asiakas.asiakasId, 14).asiakasSettingJSON;
  if (!j) return [];
  return JSON.parse(j);
}
